const translationsEn = {
    priceCalculator: {
        ExternalWashingTitle: "External Washing",
        ExternalWashingDescription: "Cleaning of the exterior bodywork, cleaning of windows, cleaning of rims, application of a tire product.",
        InternalWashingTitle: "Internal Washing",
        InternalWashingDescription: "Vacuuming of the cabin, cleaning of dashboards and interior windows.",
        SanitationTitle: "Sanitation",
        SanitationDescription: "Disinfection of surfaces and purification of the air in the air conditioning system.",
        GlassShieldTitle: "Windshield Protection",
        GlassShieldDescription: "Coating providing water-repellent and sealing properties to the windshield: promotes the sliding of raindrops, allowing not to use the wipers above 70 km/h.",
        GlassCoatingTitle: "Windshield Protection",
        GlassCoatingDescription: "Coating providing water-repellent and sealing properties to the windshield: promotes the sliding of raindrops, allowing not to use the wipers above 70 km/h.",
        PolishingTitle: "Polishing",
        PolishingDescription: "Application of a polishing wax that enhances the shine of the bodywork after washing.",
        CeramicCoatingTitle: "Ceramic Coating",
        CeramicCoatingDescription: "Treatment to restore the shine of the bodywork, thanks to its water-repellent properties which increase the duration of the wash and provide a soft touch sensation.",
        PremiumTyreDressingTitle: "Premium Tire Treatment",
        PremiumTyreDressingDescription: "Application of a high-quality protective product that restores the 'factory new' appearance of the tires for hundreds of kilometers.",
        EngineBayWashingTitle: "Engine Bay Washing",
        EngineBayWashingDescription: "Cleaning of the engine compartment, focusing on the removal of dust and grease from components.",
        pageTitle: "Where would you like to book the car wash?",
        selectCityTitle: "Select the city",
        selectCityPlaceholder: "Select a city",
        selectModelTitle: "Select your vehicle model and discover the cost of the wash",
        selectBrandPlaceholder: "Select the brand",
        selectModelPlaceholder: "Select the model",
        servicesNotSelectedInfo: "To continue, please enter your vehicle information",
        baseServicesTitle: "Choose the services you want",
        premiumServicesTitle: "Add premium services (optional)",
        washingDurationMessage: "Your wash will take approximately {0} minutes",
        genericScooterBrandModel: "All",
        baseServicesMissingWarningTitle: "Missing basic service!",
        baseServicesMissingWarningBody: "You must first select one of the basic services.",
        noServicesCombinationWarningTitle: "Combination not supported!",
        noServicesCombinationWarningBody: "It is not possible to determine the price by adding this service to the combination.",
        durationWarningTitle: "The washing duration may vary depending on the condition of the vehicle",
        resetSearch: "New Search",
        title: "Wash Out Washing Prices",
        subtitle: "To discover the cost of home washing for your vehicle, use the menu below: interior wash, exterior wash, disinfection, and premium services."
    },
    areas: {
        title: "Wash Out Coverage Areas",
        subtitle: "Discover the coverage areas for each city",
        milanoText: "Milan",
        romaText: "Rome",
        torinoText: "Turin",
        parigiText: "Paris",
    },
    cities: {
        title: "Discover the cities where the service is active",
        searchPlaceholder: "Check if your address is covered",
        milanoText: "Milan",
        romaText: "Rome",
        torinoText: "Turin",
        parigiText: "Paris",
        noResultsText: "Sorry, the selected address is not covered by the service",
        noResultsButtonText: "Discover active cities",
        resultsText: "The address is covered by the service, book now!",
        resultsButtonText: "Book a wash"
    }
}
